import { render, staticRenderFns } from "./ManagementGroupList.vue?vue&type=template&id=4ee5c27c"
import script from "./ManagementGroupList.vue?vue&type=script&lang=js"
export * from "./ManagementGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports